/**
 * Created by 丸子 on 2018/7/20 0020.
 */
import store from '../store'
import * as sessionTypes from '../store/session/types'
import Vue from 'vue'
import {stringify} from 'qs'
import Decimal from "decimal.js";

// 路径参数
export function $url(path, query) {
  if (path.indexOf('http://') === 0) {
    return path
  } else {
    const queryString = Object.keys(query || {}).map((key) => {
      return key + '=' + query[key]
    }).join('&')
    return '/' + path + '.html' + (queryString ? ('?' + queryString) : '')
  }
}

// 路径带参数
export function $gotoUrl(path, query) {
  location.assign($url(path, query))
}

// 路径不带参数
export function $webUrl(path) {
  return window.WEB_URL + path
}

// 本地开发图片路径
export function $serverImg(path) {
  if (path == null) {
    return ''
  }
  if (process.env.NODE_ENV === 'production') {
    return window.IMG_HOST + path
  }
  return window.IMG_HOST + path
}

// catch
export function $alertAxiosError(error) {
  if (error.response && error.response.data && error.response.data.code === '403') {
    Vue.prototype.$message.error(error.response.data.msg)
    window.location.href = 'login.html'
    return
  }
  if (error.response) {
    Vue.prototype.$message.error(`${error.response.data && error.response.data.msg || '未知错误'}`)
    return;
  } else {
    Vue.prototype.$message.error(`请求数据失败: ${error.message || ''}`)
    return;
  }
  // return Promise.reject(error)
}

// 时间转换0000-00-00
export function $getTimeNew(dateStr, fmt = 'YYYY-mm-dd HH:MM:SS') {
  if (Object.prototype.toString.call(dateStr) === '[object string]') {
    dateStr = dateStr.replace(/-/g, '/')
  } else if (Object.prototype.toString.call(dateStr) === '[object Number]') {
    if (dateStr.toString().length < 13) {
      dateStr = dateStr * 1000
    }
  }
  const date = new Date(dateStr)
  let ret;
  let opt = {
    "Y+": date.getFullYear().toString(),        // 年
    "m+": (date.getMonth() + 1).toString(),     // 月
    "d+": date.getDate().toString(),            // 日
    "H+": date.getHours().toString(),           // 时
    "M+": date.getMinutes().toString(),         // 分
    "S+": date.getSeconds().toString()          // 秒
    // 有其他格式化字符需求可以继续添加，必须转化成字符串
  };
  for (let k in opt) {
    ret = new RegExp("(" + k + ")").exec(fmt);
    if (ret) {
      fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
    }
  }
  return fmt;
}
// 转化为 千分位
export function $format(num){
  if(!num){return 0}
  num=num.toString().split(".");  // 分隔小数点
  var arr=num[0].split("").reverse();  // 转换成字符数组并且倒序排列
  var res=[];
  for(var i=0,len=arr.length;i<len;i++){
    if(i%3===0&&i!==0){
      res.push(",");   // 添加分隔符
    }
    res.push(arr[i]);
  }
  res.reverse(); // 再次倒序成为正确的顺序
  if(num[1]){  // 如果有小数的话添加小数部分
    res=res.join("").concat("."+num[1]);
  }else{
    res=res.join("");
  }
  return res;
}

//一分钟以内 刚刚
//1-60分钟以内 分钟前
//1-24小时以内 小时前
//1-30天 天前
//30天以上 年月日时分秒
export function $getTimeChange(dateStr) {
  dateStr = dateStr * 1000
  let delta = (Date.now() - new Date(dateStr).getTime()) / 1000
  if (delta < 60) {
    return this.i18n.lang==='zh'?'刚刚':'Just'
  }
  delta = Math.floor(delta / 60)
  if (delta < 60) {
    return this.i18n.lang==='zh'?delta +'分钟前':delta +  'Mins Ago'
  }
  delta = Math.floor(delta / 60)
  if (delta < 24) {
    return this.i18n.lang==='zh'?delta +'小时前':delta +  'Hours Ago'
  }
  delta = Math.floor(delta / 24)
  if (delta < 30) {
    return this.i18n.lang==='zh'?delta +'天前':delta +  'Days Ago'
  }
  return $getTimeNew(dateStr,'YYYY-mm-dd')
}

export function  $formatAddress(address) {
  if (!address) return '';
  return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
}

/**
 * 截取小数点后指定位数（不四舍五入）
 * @param {number|string} value - 需要处理的数值
 * @param {number} num - 需要保留的小数位数，默认为4
 * @returns {string} - 截取后的字符串
 */
export function $formatDecimals(value, num = 4) {
  if (!value && value !== 0) return '0';

  try {
    // 转换为字符串
    let strValue = String(value);
    
    // 查找小数点位置
    const dotIndex = strValue.indexOf('.');
    
    // 如果没有小数点或小数点后的位数少于指定位数，直接返回原值
    if (dotIndex === -1) return strValue;
    
    // 计算需要截取的长度（小数点位置 + 1 + 指定小数位数）
    const endIndex = dotIndex + 1 + num;
    
    // 如果小数部分长度不足指定位数，直接返回原值
    if (strValue.length <= endIndex) return strValue;
    
    // 直接截取，不进行四舍五入
    return strValue.substring(0, endIndex);
  } catch (error) {
    console.error('格式化数字错误:', error);
    return '0';
  }
}

export function $formatWithCommas(value, num = 2) {
  if (!value && value !== 0) return '0';

  try {
    // 先使用 $formatDecimals 截取小数位数
    let formattedValue = $formatDecimals(value, num);

    // 分隔小数点
    let parts = formattedValue.toString().split(".");

    // 处理整数部分，添加千位分隔符
    let integerPart = parts[0];
    let arr = integerPart.split("").reverse();
    let res = [];

    for (let i = 0, len = arr.length; i < len; i++) {
      if (i % 3 === 0 && i !== 0) {
        res.push(",");
      }
      res.push(arr[i]);
    }

    res.reverse();

    // 如果有小数部分，添加回来
    if (parts[1]) {
      return res.join("").concat("."+parts[1]);
    } else {
      return res.join("");
    }
  } catch (error) {
    console.error('格式化数字错误:', error);
    return '0';
  }
}